import { CustomStatuses, Patient } from '@csp/csp-common-model';
import { DemographicValuesMapper, ScheduleReferenceDates } from '@csp/csp-common-scheduling';
import { CustomStatusMapper } from '@csp/csp-common-custom-status';

const fromPatient = (
  patient: Patient,
  statuses?: CustomStatuses, // Overrides customStatuses in patient
): ScheduleReferenceDates => {
  const demographicValues = DemographicValuesMapper.fromPatient({
    ...patient,
    customStatuses: statuses ?? patient.customStatuses,
  });

  return {
    userCustomStatuses: statuses ?? patient.customStatuses,
    userDemographicValues: demographicValues,
  };
};

/**
 *  Get the schedule reference dates based on a patient's custom statuses.
 *  Pause related custom statuses are excluded from the result, as it's handled separately by respective domain */
const fromPatientExcludingStatusTypes = (patient: Patient, excludeTypes: string[]): ScheduleReferenceDates => {
  const statuses = CustomStatusMapper.from(
    patient.customStatuses.statuses.filter(status => !excludeTypes.includes(status.type)),
  );

  return fromPatient(patient, statuses);
};

export const ScheduleReferenceDateService = {
  fromPatient,
  fromPatientExcludingStatusTypes,
};
